/** @jsxImportSource @emotion/react */
import React from "react";
import "../SwapAndSend";
import { css } from "@emotion/react";
import { GlobalStore } from "../../../store/global/GlobalStore";

export interface SwapAndSendErrorProps {
  visible?: boolean;
}

export const SwapAndSendError: React.FC<SwapAndSendErrorProps> = ({ visible }) => {
  const receiverError = GlobalStore.useState(s => s.receiverError); // What user typed
  if (!visible) {
    return null;
  }

  const errorCss = css`
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    color: #fb7b88;
  `;

  return (
    <div
      className="d-flex align-items-start justify-content-center mt-3 mb-3"
      data-testid="swap-and-send-error"
    >
      <span css={errorCss}>{receiverError}</span>
    </div>
  );
};
